import { fetchAllMultiStoreOperators } from '@/services/multiStoreOperators'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
}

/**
 * Initial state
 */
const state = {
  loading: false,
  multiStoreOperators: undefined
}

/**
 * Getters
 */
const getters = {}

/**
 * Actions
 */
const actions = {
  fetchAllMultiStoreOperators({ commit }) {
    commit(mutationTypes.FETCHING)

    return fetchAllMultiStoreOperators()
      .then((multiStoreOperators) => {
        commit(mutationTypes.FETCHED, multiStoreOperators)
      })
      .catch((err) => {
        console.log(err)
        commit(mutationTypes.FETCHED)
      })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },

  [mutationTypes.FETCHED](state, multiStoreOperators) {
    state.multiStoreOperators = multiStoreOperators
    state.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
